import { useSignInMutation, GetInitialUserDocument } from 'gqlTypes'
import {
  createPersonalAuthorization,
  getAllAuthorizations,
  replaceAllAuthorizations,
  setUserAuthorization,
} from 'graphql/multisession'

import useUserProfile from '../useUserProfile'
import { useFetchInitialUser } from './useFetchInitialUser'
import { trackEvent } from 'modules/analytics'

export const useSignIn = ({
  onCompleted,
  onError,
}: {
  onCompleted?: () => void
  onError?: (message: string) => void
}) => {
  const { data: currentUserData } = useUserProfile()
  const fetchInitialUser = useFetchInitialUser()

  return useSignInMutation({
    awaitRefetchQueries: true,
    refetchQueries: [{ query: GetInitialUserDocument }],
    update: async (cache, { data }) => {
      if (!data) return

      const newAuthorization = createPersonalAuthorization(
        data.signIn!.credentials!
      )

      /* Save the user credentials in the apollo cache */
      setUserAuthorization(cache, newAuthorization)

      const allAuths = getAllAuthorizations()

      if (allAuths.length > 1) {
        const newUser = await fetchInitialUser()

        if (currentUserData?.me?.identifier !== newUser?.identifier) {
          replaceAllAuthorizations(newAuthorization)
        }
      }
    },
    onCompleted: () => {
      onCompleted?.()
      trackEvent('Successful SignIn', { type: 'password' })
    },
    onError: error => onError?.(error.message),
  })
}
